(function () {
  'use strict';

  angular.module('app').component('tourListSearch', tourListSearch());

  function tourListSearch() {
    return {
      bindings: {
        onTourOptionScheduleSelected: '&',
        tourIdSelected: '<',
        tourOptionScheduleIdSelected: '<',
        tours: '<',
        showToursSearch: '<',
      },
      controller: TourListSearchComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tours/components/tour-list-search/tour-list-search.component.html',
    };
  }

  TourListSearchComponent.$inject = ['CONFIGURATIONS', 'moment', 'TourService'];

  function TourListSearchComponent(config, moment, TourService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.hourDisplay = config.HOUR_DISPLAY;

    vm.filterByText = null;

    vm.$onInit = function () {
      if (!vm.tourIdSelected) {
        getTours();
      } else {
        vm.filteredTours = vm.tours;
      }
    };

    // public methods
    // -----------------------
    vm.filterTours = function () {
      if (vm.filterByText || vm.location_id) {
        let toursFiltered = [];
        let toursCopy = angular.copy(vm.tours); // important

        toursCopy.forEach(function (tour) {
          if (
            (vm.filterByText && vm.filterByText !== '') ||
            (vm.location_id && tour.location_id === vm.location_id)
          ) {
            let item;
            let itemFound = false;
            let res;

            if (vm.filterByText && vm.filterByText !== '') {
              res = searchToursNamesByText(tour);

              if (res.tour_options.length > 0) {
                item = res;
                itemFound = true;
              }
            }

            if (!res) {
              item = tour;
            }

            if (vm.location_id) {
              itemFound = false;

              if (vm.location_id === item.location_id) {
                itemFound = true;
              }
            }

            if (itemFound) {
              toursFiltered.push(item);
            }
          }
        });

        vm.filteredTours = toursFiltered;
      } else {
        vm.filteredTours = vm.tours;
      }
    };

    vm.clearSearch = function () {
      vm.filterByText = '';

      vm.filteredTours = vm.tours;
    };

    vm.selectTourOptionSchedule = function (tour, tourOption, tourOptionSchedule) {
      // Avoid calling the date of it is the same schedule
      if (vm.tourOptionScheduleIdSelected === tourOptionSchedule.id) {
        return;
      }

      vm.tourIdSelected = tour.id;
      vm.tourOptionScheduleIdSelected = tourOptionSchedule.id;

      if (!tour.service_items_cost_based) {
        tour = setServiceAvailableServiceItemByScheduleSelected(tour, tourOptionSchedule);
      }

      vm.onTourOptionScheduleSelected({
        tour: tour,
        tourOption: tourOption,
        tourOptionSchedule: tourOptionSchedule,
      });
    };

    // private methods
    // -----------------------
    function getTours() {
      let params = {
        get: 'active',
        search: true,
        taxes: true,
        skip_check_role: true,
      };

      vm.loadingTours = true;
      TourService.getTours(params).then(function (data) {
        vm.tours = data.items.filter((tour) => tour.tour_options.length > 0);
        vm.filteredTours = vm.tours;

        // order by order for future implementations

        vm.loadingTours = false;
      });
    }

    function searchToursNamesByText(tour) {
      let filterByText = vm.filterByText.toLowerCase() || '';

      // Find by name
      if (tour.name.toLowerCase().match(filterByText)) {
        return tour;
      } else {
        // Find by tour options
        let options = [];

        if (tour.tour_options) {
          tour.tour_options.forEach(function (option) {
            if (option.name && option.name.toLowerCase().match(filterByText)) {
              options.push(option);
            } else {
              // Find by tour option schedules
              let schedules = [];

              option.tour_option_schedules.forEach(function (schedule) {
                let scheduleTime = moment(schedule.departure, 'HH:mm').format('h:mm');
                let filterTime = moment(filterByText, 'HH:mm').format('h:mm');

                if (scheduleTime === filterTime) {
                  schedules.push(schedule);
                }
              });

              option.tour_option_schedules = schedules;

              if (option.tour_option_schedules.length > 0) {
                options.push(option);
              }
            }
          });
        }

        tour.tour_options = options;

        return tour;
      }
    }

    function setServiceAvailableServiceItemByScheduleSelected(tour, tourOptionSchedule) {
      let associatedServiceItemsEnabled = [];

      tour.associated_service_items.forEach(function (associatedServiceItem) {
        let serviceItemSchedules = associatedServiceItem.associated_service_item_schedules.filter(
          function (serviceItemSchedule) {
            return (
              serviceItemSchedule.tour_option_schedule_id === tourOptionSchedule.id &&
              serviceItemSchedule.enabled
            );
          }
        );

        if (serviceItemSchedules.length > 0) {
          associatedServiceItem.associated_service_item_schedule = serviceItemSchedules[0];
          associatedServiceItemsEnabled.push(associatedServiceItem);
        }
      });

      tour.associated_service_items = associatedServiceItemsEnabled;

      return tour;
    }
  }
})();
